﻿import { IHashData } from "../../IHashData";
import { IPage } from "../../IPage";
import { MainSite } from "../../MainSite";
import { ParameterSets } from "../../Model/ClientConf/UserClientConf";
import { AddIssueDialog } from "./AddIssueDialog";
import { DownloadDialog } from "./DownloadDialog";
import { ParameterSetList } from "./ParameterSetList";
import { ParameterTree } from "./ParameterTree";
import { PlottingToolbar } from "./PlottingToolbar";
import { InfluxDataWrapper } from "../../InfluxDb/InfluxDataWrapper";
import { GroupPermissionType } from "../../API/GroupPermissions/GroupPermissions";
import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { Chart } from "./Chart";

export class PlottingPage implements IPage {
    constructor(public mainSite: MainSite) {
        $(window).resize(() => {
            if (this.container) {
                let widthOfSideBarBeforeWindowResize = $('.midi_PlottingPage_series_panel_sideContainer.ui-resizable')
                    .width();
                $('.midi_PlottingPage_series_panel_sideContainer.ui-resizable')
                    .css('left', $(window).width() - widthOfSideBarBeforeWindowResize - 10);
                this.resizeChart();
            }
        });
    }

    public _debug: boolean = false; //: CONSOLE: Icon.Midi.WebApplication.FrontEnd.MainSite.instance.pages[2]._debug = true;

    public id: string = 'plot';

    private navBarLink: JQuery;

    private visible: boolean = false;
    private regionId: string;

    public delayUpdate: boolean = false;
    private delayUpdateCounter: number = 0;

    public desiredResolution: number = 0;

    public customLimitsByAxisLabel: ParameterSets.PlotAxisConfigsByAxis = {};

    public resetCustomLimits(limits: ParameterSets.PlotAxisConfigsByAxis = null): void {
        this.customLimitsByAxisLabel = {};

        if (limits !== null && typeof limits !== "undefined") {
            this.customLimitsByAxisLabel = limits;
        }
    }

    public initialize(): void {
        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);

        $('<a></a>')
            .attr('href', '#')
            .click(() => {
                this.mainSite.changePage(this.id);
                return false;
            })
            .text('Plot')
            .appendTo(this.navBarLink);
    }

    public handleHashChange(hashData: IHashData): boolean {
        if (hashData.Page === this.id) {
            this.navBarLink.addClass('active');

            if (hashData.Region !== this.regionId) {
                this.regionId = this.mainSite.hashData.Region;

                this.hide();

                if (this.container) {
                    // all messy but required
                    this.pageUnblock();
                    this.container.remove();
                    this.container = null;
                    this.chart = null;
                    this.plotData = [];
                    this.fromMoment = null;
                    this.toMoment = null;
                }
            }

            if (!this.visible) {
                this.render();
            }
            return true;
        }
        else {
            this.navBarLink.removeClass('active');
            if (this.visible) {
                this.hide();
            }
            return false;
        }
    }

    private container: JQuery = null;
    
    private toolbar: PlottingToolbar;
    private chart: Chart;
    public parameterTree: ParameterTree;
    public parameterSetList: ParameterSetList;

    private fromMoment: moment.Moment = null;
    private toMoment: moment.Moment = null;
    private groupingApproximation: string = "high"
    private dataFunction: string = "none"
    private momentFormatDebug: string = "YYYY-MM-DD HH:mm:ss ZZ (X)";
    private refreshIntervalSeconds: number = -1;
    private refreshIntervalElapsed: number = 0;
    private refreshIntervalId: number = null; // for setInterval...
    private refreshDataMinutesBefore: number = 10; // Number of minutes to refresh before now...

    private sideContainer: JQuery = null;
    private $sidePanelTop: JQuery;
    private $sidePanelBottom: JQuery;

    public $panelsWrap: JQuery;
    public $panelLeft: JQuery;
    public $panelRight: JQuery;
    public $panelRightTop: JQuery;
    public $panelRightBottom: JQuery;

    private render(): void {
        if ($.isEmptyObject(this.mainSite.staticDataManager.Schema.RegionSet.Regions)) {
            console.warn('PlottingPage.render() - no Regions available!');
            if (!this.container) {
                this.container = $('<div class="plot-page--main-wrap no-select"></div>');
                this.container.appendTo('body');
            }
            this.container.html('<div class="container"><div class="row"><div class="alert alert-danger" style="margin: 80px;">Your Account on this site does not seem to have any Permissions set or access to any Regions.</div></div></div>');
            return;
        }

        if (!this.container) {
            this.container = $('<div class="plot-page--main-wrap no-select"></div>'); //.appendTo('body');
            this.toolbar = new PlottingToolbar(this.mainSite, this);
            this.toolbar.nav.appendTo(this.container);

            //: setup panels for resizable elements:
            this.$panelsWrap = $('<div class="plot-page--panels-wrap"></div>').appendTo(this.container);
            this.$panelLeft = $('<div class="plot-page--panels-left"></div>').appendTo(this.$panelsWrap);
            let $splitterVertical: JQuery = $('<div class="plot-page--splitter splitter-vertical"></div>').appendTo(this.$panelsWrap);
            this.$panelRight = $('<div class="plot-page--panels-right"></div>').appendTo(this.$panelsWrap);

            this.$panelRightTop = $('<div class="plot-page--panels-right--top"></div>').appendTo(this.$panelRight);
            let $splitterHorizontal: JQuery = $('<div class="plot-page--splitter splitter-horizontal"></div>').appendTo(this.$panelRight);
            this.$panelRightBottom = $('<div class="plot-page--panels-right--bottom"></div>').appendTo(this.$panelRight);

            //: apply resizable panels: (SEE: https://github.com/RickStrahl/jquery-resizable)
            this.$panelRight.resizableSafe({
                handleSelector: ".plot-page--splitter.splitter-vertical",
                resizeHeight: false,
                resizeWidthFrom: 'left',
                onDragStart: (e, $el, opt) => {
                    $splitterVertical.addClass("resizing");
                },
                onDragEnd: (e, $el, opt) => {
                    $splitterVertical.removeClass("resizing");
                    MainSite.localStorageSet('plotSideBarWidth', this.$panelRight.width().toString());
                    this.resizeChart();
                }
            });
            this.$panelRightTop.resizableSafe({
                handleSelector: ".plot-page--splitter.splitter-horizontal",
                resizeWidth: false,
                onDragStart: (e, $el, opt) => {
                    $splitterHorizontal.addClass("resizing");
                },
                onDragEnd: (e, $el, opt) => {
                    $splitterHorizontal.removeClass("resizing");
                    MainSite.localStorageSet('plotSideBarTopPanelHeight', this.$panelRightTop.height().toString());
                }
            });

            //: apply locally stored panel sizes if possible:
            let sideBarWidth: number = 280;
            let lsWidth = parseFloat(MainSite.localStorageGet('plotSideBarWidth', null));
            if (!isNaN(lsWidth)) {
                sideBarWidth = lsWidth;

                if (sideBarWidth > ($(window).width() * 0.45) || sideBarWidth < 280) {
                    sideBarWidth = 280;
                    MainSite.localStorageSet('plotSideBarWidth', null);
                }
            }
            this.$panelRight.width(sideBarWidth);

            let topPanelHeight: number = 180;
            let lsHeight = parseFloat(MainSite.localStorageGet('plotSideBarTopPanelHeight', null));
            if (!isNaN(lsHeight)) {
                topPanelHeight = lsHeight;
                this.$panelRightTop.height(topPanelHeight);
            }


            //: add other elements:
            let $chartBox: JQuery = $('<div>').addClass('padded-box fill-space').appendTo($('<div>').addClass('plot-page--panels--inner fill-space').appendTo(this.$panelLeft));
            let $paramTreeBox: JQuery = $('<div>').addClass('padded-box fill-space flex-col-wrap').appendTo($('<div>').addClass('plot-page--panels--inner fill-space').appendTo(this.$panelRightBottom));
            let $paramSetsBox: JQuery = $('<div>').addClass('padded-box fill-space flex-col-wrap').appendTo($('<div>').addClass('plot-page--panels--inner fill-space').appendTo(this.$panelRightTop));

            this.chart = new Chart(this.mainSite, this);
            this.chart.containerDiv.appendTo($chartBox);

            this.parameterTree = new ParameterTree(this.mainSite, this);
            this.parameterSetList = new ParameterSetList(this.mainSite, this.parameterTree, $paramSetsBox, this);

            let paramsTitleContainer = $('<div class="midi_PlottingPage_series_panel_sideContainer_parametersTitle flex-col-item--no-grow"></div>').appendTo($paramTreeBox);
            $('<h5></h5>').text("Parameters").appendTo(paramsTitleContainer);
            this.parameterSetList.getSaveButton().appendTo(paramsTitleContainer);
            this.parameterTree.setupTreeToolbar(paramsTitleContainer);
            this.parameterTree.tree.appendTo($paramTreeBox);
            this.toolbar.click30();
        }

        this.container.appendTo('body');
        this.visible = true;
        this.resizeChart();
    }

    private hide(): void {
        if (this.visible) {
            this.pageUnblock();
            this.container.detach();
            if (this.downloadDialog) {
                this.downloadDialog.hide();
                this.downloadDialog = null;
            }
            this.visible = false;
        }

        this.refreshIntervalClear();
    }

    public resizeChart() {
        this.updateChart();
    }

    public plotData: InfluxDataWrapper[] = [];

    private stacked: boolean = false;

    public updateChart(): void {
        this.chart.drawPlot(this.plotData, this.stacked, this.fromMoment, this.toMoment, this.groupingApproximation, this.dataFunction);

        this.toolbar.plotDataChanged();
    }

    public setStacked(stacked: boolean) {
        this.stacked = stacked;
        this.updateChart();
    }

    public setDateRange(from: moment.Moment, to: moment.Moment, ignoreTimezone: boolean = false) {
        var changed = false;
        let mm = null;

        if (ignoreTimezone) {
            //old (UTC) method or if we've got moments with provided times (i.e. on afterSetExtremes() on chart):
            if (!this.fromMoment || (from && this.fromMoment.valueOf() != from.valueOf())) {
                this.fromMoment = from;
                changed = true;
            }

            if (!this.toMoment || (to && this.toMoment.valueOf() != to.valueOf())) {
                this.toMoment = to;
                changed = true;
            }
        } else {
            let mm_format: string = "YYYY-MM-DD";
            mm = this.getMomentsRange(from.format(mm_format), to.format(mm_format));

            if (!this.fromMoment || (mm.from && this.fromMoment.valueOf() != mm.from.valueOf())) {
                this.fromMoment = mm.from;
                changed = true;
            }

            if (!this.toMoment || (mm.to && this.toMoment.valueOf() != mm.to.valueOf())) {
                this.toMoment = mm.to;
                changed = true;
            }
        }


        if (this._debug) {
            console.info(`%c[PLOT PAGE]`, 'color: red; font-weight: bold', ` setDateRange(${from}, ${to})... THEN toolbar.dateRangeChanged() AND parameterTree.updateAll()`, { changed: changed, fromMoment: this.fromMoment, toMoment: this.toMoment, inputs: { f: from, t: to, mm: mm } });
        }

        if (changed) {
            this.toolbar.dateRangeChanged(this.fromMoment, this.toMoment);
            this.parameterTree.updateAll();
        }
    }

    /**
     * Helper function to get from/to moments instances with appropriate timezone settings based on user's choices. NB: this will
     * always provide a starting moment at 00:00 and ending at 23:59, considering the user's timezone setting.
     * @param fromYMD String for FROM date, YYYY-MM-DD (default uses currently set fromMoment)
     * @param toYMD String for TO date, YYYY-MM-DD (default uses currently set toMoment)
     */
    public getMomentsRange(fromYMD: string, toYMD: string, fromHms: string = "00:00:00", toHms: string = "23:59:59"): { from: moment.Moment, to: moment.Moment, debug: { f: string, t: string } } {
        let offset: string = this.mainSite.getTimeZoneStringFormat('ZZ');
        let format: string = "YYYY-MM-DD HH:mm:ssZ";

        if (!fromYMD) {
            fromYMD = this.fromMoment.format("YYYY-MM-DD");
        }
        if (!toYMD) {
            toYMD = this.toMoment.format("YYYY-MM-DD");
        }

        let f: moment.Moment = moment.parseZone(`${fromYMD} ${fromHms}${offset}`, format);
        let t: moment.Moment = moment.parseZone(`${toYMD} ${toHms}${offset}`, format);

        return {
            from: f,
            to: t,
            debug: {
                f: f.format(this.momentFormatDebug),
                t: t.format(this.momentFormatDebug)
            }
        };
    }

    /**
     * Helper to get the current moment, with considerations for user's timezone setting.
     */
    public getNowMoment(): moment.Moment {
        return moment(moment.utc()).tz(this.mainSite.getTimeZoneName());
    }

    /**
     * Checks if currently set moments range contains future moments or not.
     */
    public checkRangeHasFuture(): boolean {
        try {
            let now = this.getNowMoment();
            if (this.fromMoment < now && this.toMoment > now) {
                return true;
            } else {
                return false;
            }
        } catch (err) {
            console.warn("Unable to check if range contains future. Details:", err);
            return false;
        }
    }

    /**
     * A helper function to retrieve the currently set from/to moments in this instance.
     */
    public getCurrentMoments(): { from: moment.Moment, to: moment.Moment, debug: { f: string, t: string } } {
        return {
            from: this.fromMoment,
            to: this.toMoment,
            debug: {
                f: this.fromMoment.format(this.momentFormatDebug),
                t: this.toMoment.format(this.momentFormatDebug)
            }
        };
    }

    public setResolution(resolution: number) {
        this.desiredResolution = resolution;
        this.parameterTree.updateAll();
    }

    public setGrouping(groupingApproximation: string) {
        this.groupingApproximation = groupingApproximation;
        this.parameterTree.updateAll();
    }

    public setDataFunction(dataFunction: string) {
        this.dataFunction = dataFunction;
        this.parameterTree.updateAll();
    }

    public checkIfUserCanDownloadRegionData(regionId: string) {
        var hasPermission = false;
        this.mainSite.currentUserGroupPermissions.forEach(gp => {
            if (gp.GroupPermissionType == GroupPermissionType.ViewAndDownload && gp.GroupRules.filter(x => x.RegionId == regionId).length > 0) {
                hasPermission = true;
            }
        });
        return hasPermission;
    }

    public checkIfUserCanDownloadStationData(stationId: string) {
        var hasPermission = false;
        var stationRegions = this.mainSite.getStationsByRegions();
        var regionId = null;
        stationRegions.forEach(sr => {
            if (sr.Stations.filter(x => x.Id == stationId).length > 0) {
                regionId = sr.Region.Id;
            }
        });
        this.mainSite.currentUserGroupPermissions.forEach(gp => {
            if (gp.GroupPermissionType == GroupPermissionType.ViewAndDownload) {
                if (gp.GroupRules.filter(x => x.StationId == stationId).length > 0) {
                    hasPermission = true;
                } else {
                    if (gp.GroupRules.filter(x => x.StationId == null && x.RegionId == regionId).length > 0) {
                        //user has access to whole region
                        hasPermission = true;
                    }
                    }
            }               
        });
        return hasPermission;
    }

    public checkIfUserCanDownloadSensorData(stationId: string, sensorId: string) {
        var hasPermission = false;
        var stationRegions = this.mainSite.getStationsByRegions();
        var regionId = null;
        stationRegions.forEach(sr => {
            if (sr.Stations.filter(x => x.Id == stationId).length > 0) {
                regionId = sr.Region.Id;
            }
        });
        this.mainSite.currentUserGroupPermissions.forEach(gp => {
            if (gp.GroupPermissionType == GroupPermissionType.ViewAndDownload) {
                if (gp.GroupRules.filter(x => (x.RegionId == regionId && x.StationId == null) ||
                    (x.RegionId == regionId && x.StationId == stationId && x.SensorId == null) ||
                    (x.RegionId == regionId && x.StationId == stationId && x.SensorId == sensorId)).length > 0) {
                    hasPermission = true;
                }
            }
        });
        return hasPermission;
    }

    public setChartResolution(desiredResolution: string) {

    }

    /**
     * A helper function to concatenate data points for the chart, but removing duplicated points
     * from current data before adding new ones, to prevent duplication. Note that sorting is applied
     * to the final result before being returned, to prevent Highcharts Error #15 (expects sorted data).
     * NB: historically data was typed any[], tried to make it more accurate here...
     * @param currentData Data points expected to be in the form of array[timestamp, value]
     * @param newData Data points expected to be in the form of array[timestamp, value]
     * @returns [number, any][] Data points  expected to be in the form of array[timestamp, value], sorted by timestamp
     */
    public dataPointsConcat(currentData: [number, any][], newData: [number, any][]): [number, any][] {
        let final: any[] = [];
        final = [].concat([], currentData); //: set to current data before modifying

        if (newData.length > 0) {
            newData.sort(this.dataPointsSort);
            let tsFirstNew: number = newData[0][0] || null;
            if (tsFirstNew && !isNaN(tsFirstNew)) {
                var tsFirstNewIndex: number = this.dataPointsGetTsIndex(final, tsFirstNew);
                if (tsFirstNewIndex > -1) {
                    final.splice(tsFirstNewIndex);
                }
            }

            final = [].concat([], final, newData);
        }

        // console.info("[PLOT PAGE] dataPointsConcat()", { cur: currentData, new: newData, final: final, tsFirstNew: tsFirstNew, tsFirstNewIndex: tsFirstNewIndex });
        return final.sort(this.dataPointsSort);
    }

    /**
     * Function to sort the data points by timestamp, in ascending order
     * @param a
     * @param b
     */
    public dataPointsSort(a: [number, any], b: [number, any]): number {
        //: sorting may be performance consuming but necessary for Highcharts, otherwise we get error 15 (https://www.highcharts.com/errors/15/). Sorting may be necessary for points that are duplicated from received data.
        //: NB: here we assume that a & b are data points in form of array[timestamp, value]..
        let a2: number = a[0]; // parseInt(a[0]);
        let b2: number = b[0]; // parseInt(b[0]);

        if (a2 == b2 || isNaN(a2) || isNaN(b2)) {
            return 0;
        }
        if (a2 > b2) {
            return 1;
        }
        if (a2 < b2) {
            return -1;
        }
    }

    /**
     * Get the index of a data point in a given set for a specific timestamp
     * @param data The given set of points (in form of array[timestamp, value])
     * @param ts The timestamp to look for
     */
    public dataPointsGetTsIndex(data: [number, any][], ts: number): number {
        var index: number = -1;
        data.forEach((x: [number, any], i: number) => {
            if (x[0] == ts) {
                index = i;
            }
        });
        return index;
    }

    public addOrUpdateChartSeries(data: InfluxDataWrapper, merge: boolean = false) {

        var index = this.getPlotDataIndex(data);
        if (index >= 0) {
            if (merge) {
                this.plotData[index].Data = this.dataPointsConcat(this.plotData[index].Data, data.Data);
                this.plotData[index].TimestampFirst = data.TimestampFirst;
                this.plotData[index].TimestampLast = data.TimestampLast;
            } else {
                this.plotData[index] = data;
            }
            this.delayUpdateCounter++;
            if (this.delayUpdateCounter >= this.plotData.length) {
                this.delayUpdate = false;
                this.delayUpdateCounter = 0;
            }
        } else {
            this.plotData.push(data);
            this.delayUpdate = false; // always force delay update to false if a node clicked
            this.delayUpdateCounter = 0;
        }

        if (!this.delayUpdate) {
            this.updateChart();
        }
    }

    public removeChartSeries(data: InfluxDataWrapper) {
        var index = this.getPlotDataIndex(data);
        if (index >= 0) {
            this.plotData.splice(index, 1);
            this.delayUpdate = false; // always force delay update to false if a node clicked
            this.delayUpdateCounter = 0;
            this.updateChart();
        }
    }

    private getPlotDataIndex(data: InfluxDataWrapper) {
        var index: number = -1;
        this.plotData.forEach((data_: InfluxDataWrapper, i: number) => {
            if (data.StationId == data_.StationId && data.ParameterId == data_.ParameterId && data.SensorId == data_.SensorId && data.VariantId == data_.VariantId) {
                index = i;
            }
        });
        return index;
    }

    private downloadDialog: DownloadDialog = null;
    private addIssueDialog: AddIssueDialog = null;

    public addIssue(stationId: string, sensorId: string, parameterId: string, parameterTreeNode: Fancytree.FancytreeNode) {
        if (this.addIssueDialog) {
            this.addIssueDialog.hide();
            this.addIssueDialog = null;
        }

        this.pageBlock(`Loading Add Issue Popup`, true, (pp) => {
            this.addIssueDialog = new AddIssueDialog(stationId, sensorId, parameterId, this, this.parameterTree, parameterTreeNode);
            this.addIssueDialog.show();
        });
    }

    public downloadData(parameterSchemaStation: ParameterSchemaStation) {
        if (this.downloadDialog) {
            this.downloadDialog.hide();
            this.downloadDialog = null;
        }

        this.pageBlock(`Loading Data Download Popup for ${parameterSchemaStation.Station.Label}...`, true, (pp) => {
            this.downloadDialog = new DownloadDialog(parameterSchemaStation, this);
            this.downloadDialog.show(this.fromMoment, this.toMoment);
        });
    }

    public downloadDataAllStations() {
        if (this.downloadDialog) {
            this.downloadDialog.hide();
            this.downloadDialog = null;
        }

        this.pageBlock(`Loading Data Download Popup...`, true, (pp) => {
            this.downloadDialog = new DownloadDialog(null, this);
            this.downloadDialog.show(this.fromMoment, this.toMoment);
        });
    }

    public downloadPng() { 
        this.chart.exportChart();
    }

    public refreshIntervalSetTo(seconds: number = -1): void {
        //: DEV INFO: SET BELOW IN A WATCH LINE IN CHROME CONSOLE:
        //:    - pp = Icon.Midi.WebApplication.FrontEnd.MainSite.instance.pages[2];
        //:    - pp.getCurrentMoments().debug
        //:    - ['refresh', pp.refreshIntervalId, pp.refreshIntervalElapsed, pp.refreshIntervalSeconds, pp.checkRangeHasFuture()]

        // console.info(`%c[PLOT PAGE INTERVAL] SetTo(${seconds})`, 'color: blue;');
        let min: number = 60; //: set this to 30 or 60! (1 was set for dev testing!)
        if (seconds >= 0 && seconds < min) {
            console.error(`Plot Page: refresh interval less than ${min} seconds not permitted for performance reasons.`);
        }

        this.refreshIntervalClear();
        if (seconds >= min) {
            this.refreshIntervalElapsed = 0;
            this.refreshIntervalSeconds = seconds;
            this.refreshIntervalSetup();
        }
    }

    private refreshIntervalRun(): void {
        this.refreshIntervalElapsed++;
        if (this.refreshIntervalElapsed >= this.refreshIntervalSeconds) {
            this.refreshIntervalElapsed = 0;
            this.refreshIntervalFetchData();
        }
    }

    private refreshIntervalSetup(): void {
        if (this._debug) {
            console.info(`%c[PLOT PAGE INTERVAL] SETUP`, 'color: blue;');
        }
        if (this.refreshIntervalId === null) {
            this.refreshIntervalElapsed = 0;
            this.refreshIntervalId = setInterval(() => { this.refreshIntervalRun(); }, 1000);
        }
    }

    private refreshIntervalClear(): void {
        if (this._debug) {
            console.info(`%c[PLOT PAGE INTERVAL] CLEAR`, 'color: blue;');
        }
        if (this.refreshIntervalId !== null) {
            this.refreshIntervalElapsed = 0;
            clearInterval(this.refreshIntervalId);
            this.refreshIntervalId = null;
        }
    }

    private refreshIntervalFetchData(): void {
        if (this.checkRangeHasFuture()) {
            let latestPoints: {
                [seriesName: string]: {
                    res: number,
                    tsFirst: number,
                    tsLast: number,
                    //tsFirst_str: string,
                    //tsLast_str: string,
                    getFrom: number,
                    getTo: number,
                    //getFrom_str: string,
                    //getTo_str: string
                }
            } = {};

            let tsFrom: number = Infinity;
            let tsTo: number = 0;

            this.plotData.forEach((data: InfluxDataWrapper) => {
                let sn: string = this.chart.getSeriesNameOrId(data, this.stacked, "name");
                latestPoints[sn] = {
                    res: data.Resolution,
                    tsFirst: data.TimestampFirst,
                    tsLast: data.TimestampLast,
                    //tsFirst_str: moment(data.TimestampFirst).utc().tz(this.mainSite.getTimeZoneName()).format(this.momentFormatDebug),
                    //tsLast_str: moment(data.TimestampLast).utc().tz(this.mainSite.getTimeZoneName()).format(this.momentFormatDebug),
                    getFrom: moment(data.TimestampLast).utc().subtract(this.refreshDataMinutesBefore, "minutes").startOf('minute').valueOf(),
                    getTo: moment().utc().endOf('minute').valueOf(),
                    //getFrom_str: moment(data.TimestampLast).utc().subtract(this.refreshDataMinutesBefore, "minutes").tz(this.mainSite.getTimeZoneName()).format(this.momentFormatDebug),
                    //getTo_str: moment().utc().tz(this.mainSite.getTimeZoneName()).format(this.momentFormatDebug)
                };

                if (!isNaN(latestPoints[sn].getFrom)) {
                    tsFrom = Math.min(tsFrom, latestPoints[sn].getFrom);
                }
                if (!isNaN(latestPoints[sn].getTo)) {
                    tsTo = Math.max(tsTo, latestPoints[sn].getTo);
                }
            });

            if (tsFrom == Infinity || tsTo == 0) {
                console.warn(`%c[PLOT PAGE INTERVAL] Refresh ERROR`, 'color: red;', `The FROM or TO timestamps could not be resolved for safe API server call.`);
            } else {
                if (this._debug) {
                    console.info("REFRESH FETCH DATA", { latestPoints: latestPoints, F: tsFrom, T: tsTo });
                }
                this.parameterTree.getLatestDataAll(tsFrom, tsTo, null); //: NB: using null for resolution so methods use the currently set resolution for each node.
            }
        } else {
            if (this._debug) {
                console.warn("[PLOT PAGE] Refresh interval will not get new data as moments range does not contain current & future moments.");
            }
        }
    }

    private _pageBlockJquerySelector: string = "body"; //: NB: this should correspond to one single element, otherwise onBlock option will be executed once for each matching element! (so I've added blocking of the navbar separately!)

    public pageBlock(message: string = '', blockNavBar: boolean = true, callback?: (pp: PlottingPage) => void): void {
        let _msg: string = '';
        let progressBar: string = '<div class="progress" style="margin:0"><div class="progress-bar progress-bar-striped active" style="width: 100%"></div></div>';
        let css: { [key: string]: string } = {
            border: 'none',
            backgroundColor: 'transparent',
            color: '#fff'
        };

        let $msg: JQuery = $('<div>');
        if (message.length > 0) {
            $msg.text(message); //: use this to escape content..
            _msg = progressBar + '<div style="margin-top: 5px;">' + $msg.html() + '</div>';
        } else {
            _msg = progressBar;
        }

        if (blockNavBar) {
            $(".navbar.navbar-fixed-top").block({
                message: '',
                css: css
            });
        }

        $(this._pageBlockJquerySelector).block({
            message: _msg,
            css: css,
            onBlock: () => {
                if (typeof (callback) == "function") {
                    callback(this);
                }
            }
        });
    }

    public pageUnblock(): void {
        $(".navbar.navbar-fixed-top").unblock();
        $(this._pageBlockJquerySelector).unblock();
    }
}

